import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const useLocationsState = () => {
	return useSelector((state) => state?.locations || {});
};

const initialState = {
	data: {},
	failedToLoadADD: false,
	accountId: null,
	error: null,
	isLoading: false
};

const locationsSlice = createSlice({
	name: 'locations',
	initialState,
	reducers: {
		locationsLoading(state) {
			return {
				...state,
				isLoading: true,
				error: null
			};
		},
		locationsAdded(state, action) {
			return {
				...state,
				data: {
					...state.data,
					...action.payload
				},
				failedToLoadADD: false,
				error: null,
				isLoading: false
			};
		},
		locationsFailedToLoad(state, action) {
			return {
				...state,
				failedToLoadADD: true,
				accountId: action.payload.accountId,
				isLoading: false
			};
		},
		locationsFetchError(state, action) {
			return {
				...state,
				error: action.payload,
				isLoading: false
			};
		}
	}
});

export const {
	locationsLoading,
	locationsAdded,
	locationsFailedToLoad,
	locationsFetchError
} = locationsSlice.actions;

export default locationsSlice.reducer;
